export default {
  Imagepicker: {
    mounted() {
      this.el.querySelectorAll('.card').forEach((image) => {
        image.addEventListener('click', () => {
          // Remove highlight from all images
          this.el.querySelectorAll('.card').forEach((img) => {
            img.classList.remove('is-selected');
          });

          // Highlight selected image
          image.classList.add('is-selected');

          // Update field value
          this.el.querySelector('input[type=hidden]').value = image.dataset.imageUrl;
        });
      });
    },
  },
};
